// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__2Lz0m","lds-ring":"Loader_lds-ring__1p-wN"};